import React from "react";
import "./AboutUs.css";

function AboutUs () {
  return (
    <div className="about-container">
      <section className="about-hero">
        <h1>About Us</h1>
        <p>
          We are a passionate team dedicated to building modern, scalable, and
          user-friendly web applications.
        </p>
      </section>

      <section className="about-content">
        <div className="about-card">
          <h2>Our Mission</h2>
          <p>
            Our mission is to deliver high-quality digital solutions that help
            businesses grow and succeed in the modern world.
          </p>
        </div>

        <div className="about-card">
          <h2>Our Vision</h2>
          <p>
            We aim to become a leading tech company known for innovation,
            reliability, and customer satisfaction.
          </p>
        </div>

        <div className="about-card">
          <h2>Our Values</h2>
          <p>
            Integrity, teamwork, creativity, and continuous improvement guide
            everything we do.
          </p>
        </div>
      </section>

      <section className="about-footer">
        <h3>Want to work with us?</h3>
        <button onClick={() => alert("Thanks for reaching out!")}>
          Contact Us
        </button>
      </section>
    </div>
  );
};

export default AboutUs;